import React, { Component } from 'react'
import {connect} from 'react-redux';
import Constants from "../../../constants/constants";
import { newFunctionalSkillSession } from "../../../modules/functional_skills";
import withStaticImages from "../../../services/utils/imageNameRetriever";
import DomainUrlRedirect from './domain-url-redirect';


class FunctionalSkillCard extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: false
        }
    }

    redirectRender(){
        const{ functionalSkillSessionId, token } = this.props;
        const searchParams = {
            functional_skill_session_id: functionalSkillSessionId,
            auth: token,
            purl: "https://" + window.location.hostname
        }
        return(<DomainUrlRedirect url={Constants.getPlayContentUrl()} searchParams={searchParams} pathname={"play_game"} />)
    }
    handleClick()
    {
        const {dispatch, id, token } = this.props;
        dispatch(newFunctionalSkillSession(id, token))
        this.setState({loading:true})
    }

    render(){
        const {name, description, icon_path, functionalSkillSessionId} = this.props
        const {loading} = this.state
        return(
        <div className="tw-h-52 tw-bg-white tw-w-60 tw-rounded-md tw-relative tw-group tw-cursor-pointer tw-flex tw-place-content-center tw-shadow tw-transition tw-transform active:tw-translate-y-1"
            onClick={()=>this.handleClick()}>
            <div className="tw-bg-gray-800 tw-bg-opacity-60 tw-px-3 tw-text-center tw-absolute tw-container tw-rounded-t-md tw-h-12">
                <h1 className="tw-mt-1 tw-text-gray-50 tw-text-lg tw-leading-tight">{name}</h1>
            </div>
            <div className="tw-h-0 group-hover:tw-h-40 tw-overflow-ellipsis tw-absolute tw-bottom-0 tw-container tw-bg-gray-800 tw-bg-opacity-60 group-hover:tw-bg-gray-600 group-hover:tw-bg-opacity-60 tw-rounded-b-md tw-text-left tw-px-2">
                    <p className="tw-text-gray-50 tw-mt-8 tw-hidden group-hover:tw-block">{description}</p>
            </div>
            <div className=" tw-mt-12 tw-justify-self-center tw-align-bottom">
                <img src={this.props.getImage(icon_path)} alt="Lean Squat Position Exercise" className=" tw-h-40"></img>
            </div>
            {loading &&
                <div className=" tw-bg-gray-100 tw-absolute tw-top-0 tw-h-52 tw-rounded-md tw-z-20 tw-w-60 tw-opacity-80 tw-text-center">
                    <p className="tw-text-lg tw-mt-14 tw-text-gray-900">Starting session <i className="fa fa-spinner fa-spin"></i></p>
                </div>
            }
            { functionalSkillSessionId !== null && this.redirectRender() }
        </div>)
    }
}

const withState = connect((state, props) =>{
    const { user, functionalSkills} = state;
    const { id } = props;
    const myFSSId = functionalSkills.functionalSkillSessionIds[id]
    return {
        token: user.token,
        functionalSkillSessionId: typeof myFSSId === 'undefined'?null: myFSSId
    }

})

export default withState(withStaticImages('quick-play-icons',FunctionalSkillCard));


// WEBPACK FOOTER //
// ./src/components/components/functional-skill-card/functional-skill-card.js